import React, { createContext, useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from './UserContext';
import { SrxApi } from '../api/SrxApi';

export const SelectedFacilitiesContext = createContext();

export const SelectedFacilitiesProvider = (props) => {

    let history = useHistory();

    // const { faciToken, setFaciToken } = useContext(UserContext);
    const { faciToken, setFaciToken, userLoading } = useContext(UserContext);

    const SELECTED_FACILITIES_STORAGE_KEY = 'SELECTED_FACILITIES_FILTER';

    const [selectedFacilities, setSelectedFacilities] = useState(() => {
        try {
            const storedFacilities = localStorage.getItem(SELECTED_FACILITIES_STORAGE_KEY);
            return storedFacilities ? JSON.parse(storedFacilities) : [];
        } catch (err) {
            console.debug('Could not load selected facilities from localStorage', err);
            return [];
        }
    });
    // const [selectedFacilities, setSelectedFacilities] = useState([]);

    const [facilities, setFacilities] = useState([])

    // useEffect(() => {
    //     if (faciToken) {
    //         // Ensure Authorization header is set on SrxApi
    //         SrxApi.defaults.headers.common['Authorization'] = 'bearer ' + faciToken;

    //         SrxApi.get('/facilities')
    //             .then(res => {
    //                 // Ensure we always set an array
    //                 const facilitiesData = res.data?.facilities || res.data;
    //                 if (Array.isArray(facilitiesData)) {
    //                     setFacilities(facilitiesData);
    //                 } else {
    //                     console.warn('Facilities data is not an array:', facilitiesData);
    //                     setFacilities([]);
    //                 }
    //             })
    //             .catch(err => {
    //                 console.error('Error fetching facilities:', err);
    //                 // Set empty array on error to prevent undefined issues
    //                 setFacilities([]);
    //                 if (err.response?.status === 401) {
    //                     localStorage.removeItem('FACI_TOKEN');
    //                     setFaciToken(null);
    //                     history.replace('/account/login')
    //                 }
    //             })
    //     } else {
    //         setSelectedFacilities([]);
    //         setFacilities([]);
    //     }
    // }, [faciToken])

    useEffect(() => {
        if (userLoading) return;

        if (faciToken) {
            SrxApi.defaults.headers.common['Authorization'] = 'bearer ' + faciToken;

            SrxApi.get('/facilities')
                .then(res => {
                    const facilitiesData = res.data?.facilities || res.data;
                    if (Array.isArray(facilitiesData)) {
                        setFacilities(facilitiesData);
                    } else {
                        console.warn('Facilities data is not an array:', facilitiesData);
                        setFacilities([]);
                    }
                })
                .catch(err => {
                    console.error('Error fetching facilities:', err);
                    setFacilities([]);
                    if (err.response?.status === 401) {
                        localStorage.removeItem('FACI_TOKEN');
                        localStorage.removeItem(SELECTED_FACILITIES_STORAGE_KEY);
                        setSelectedFacilities([]);
                        setFaciToken(null);
                        history.replace('/account/login');
                    }
                });
        } else {
            setSelectedFacilities([]);
            setFacilities([]);
            localStorage.removeItem(SELECTED_FACILITIES_STORAGE_KEY);
        }
    }, [faciToken, userLoading]);

    useEffect(() => {
        try {
            if (selectedFacilities.length > 0) {
                localStorage.setItem(
                    SELECTED_FACILITIES_STORAGE_KEY,
                    JSON.stringify(selectedFacilities)
                );
            } else {
                localStorage.removeItem(SELECTED_FACILITIES_STORAGE_KEY);
            }
        } catch (err) {
            console.debug('Could not persist selected facilities to localStorage', err);
        }
    }, [selectedFacilities]);

    return (
        <SelectedFacilitiesContext.Provider value={{ selectedFacilities, setSelectedFacilities, facilities }}>
            {props.children}
        </SelectedFacilitiesContext.Provider>
    );
}